import _ from 'underscore';
import React from 'react';
import { QueryParam } from './query-param';
import { verifyRouter } from './verify-router';
import {
  ILocation, IHistory, IProcessor, IRouterProps, ScopeExtraData,
} from '../types';

export function withQueryStringInternal<
  P extends object,
  K extends string = 'queryParams',
>(
  Component: React.ComponentType<P & Record<K, QueryParam>>,
  propName: K = 'queryParams' as K,
  processor: IProcessor = _.identity,
): React.FC<Omit<P, K> & IRouterProps> {
  const WrappedComponent: React.FC<Omit<P, K> & IRouterProps> = (props) => {
    const {
      location = {} as ILocation,
      history = {} as IHistory,
      ...rest
    } = props;

    const saveScope = (
      scope: QueryParam,
      pathname: string = location.pathname,
      _extraData?: ScopeExtraData,
    ) => {
      if (pathname !== location.pathname || !scope.isEqual(location.search)) {
        history.push({
          pathname,
          search: scope.stringify(),
        });
      }
    };
    const queryParam = new QueryParam(
      location,
      history,
      saveScope,
      processor,
    );
    const queryProp = { [propName]: queryParam } as Record<K, QueryParam>;

    return (
      <Component
        {...queryProp}
        {...rest as P}
      />
    );
  };

  return WrappedComponent;
}

export const withQueryString = _.compose(verifyRouter, withQueryStringInternal);
